// Foundations
import { Component, OnInit, EventEmitter, Output } from '@angular/core';

// Services
import { MyProfileService } from 'src/app/services/my-profile.service';

// Models
import { FranchiseLocation } from '../../../../models/franchise.model';

@Component({
  selector: 'app-camp-locations-list',
  templateUrl: './camp-locations-list.component.html',
  styleUrls: ['./camp-locations-list.component.scss'],
})
export class CampLocationsListComponent implements OnInit {
  @Output() showEditPreferredLocation = new EventEmitter<number>();

  locationTiles: FranchiseLocation[];

  constructor(public myProfileService: MyProfileService) {}

  ngOnInit(): void {}

  handleClicked(): void {
    this.showEditPreferredLocation.emit(1);
  }
}
